import { Input } from "components/ui/input";
import { ChangeEvent, FocusEventHandler, KeyboardEventHandler, WheelEventHandler, forwardRef } from "react";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

interface NumberInputProps {
  id?: number | string;
  maxLength?: number;
  minLength?: number;
  value?: string | number | readonly string[];
  placeholder?: string;
  onFocus?: FocusEventHandler<HTMLInputElement>;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: KeyboardEventHandler<HTMLInputElement>;
  className?: string;
  disabled?: boolean;
  defaultValue?: string | number | readonly string[];
  name?: string;
  type?: string;
}

// ✅ Use forwardRef to expose ref to parent
const NumberInput = forwardRef<HTMLInputElement, NumberInputProps>(
  ({ value, placeholder, onFocus, onBlur, onChange, onKeyDown, className, disabled, maxLength, minLength, defaultValue, name, type = "number" }, ref) => {
    // ✅ Prevent mouse scroll changing the number
    const handleWheel: WheelEventHandler<HTMLInputElement> = (e) => {
      e.currentTarget.blur(); // remove focus to prevent scroll increment
    };

    return (
      <Input
        ref={ref}
        type={type}
        defaultValue={defaultValue}
        value={value}
        minLength={minLength}
        maxLength={maxLength}
        className={`${className} focus:border-none focus:border-1 text-[15px]`}
        placeholder={placeholder}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={onChange}
        onKeyDown={onKeyDown}
        onWheel={handleWheel} // 👈 attach handler here
        disabled={disabled}
        name={name}
      />
    );
  }
);

export default NumberInput;
